import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment.local';
import {Annexe} from '../../models/annexes/AnnexeBody';

@Injectable({
  providedIn: 'root'
})
export class AnnexesService {

  private apiUrl = `${environment.apiUrl}/annexes`;

  constructor(private http: HttpClient) { }

  getAnnexes(): Observable<Annexe[]> {
    return this.http.get<Annexe[]>(this.apiUrl);
  }

  getAnnexeById(id: number): Observable<Annexe> {
    return this.http.get<Annexe>(`${this.apiUrl}/${id}`);
  }

  postAnnexe(formData: FormData): Observable<string[]> {
    return this.http.post<string[]>(this.apiUrl, formData);
  }

  updateAnnexe(id: number, annexe: Annexe): Observable<Annexe> {
    return this.http.put<Annexe>(`${this.apiUrl}/${id}`, annexe);
  }

  deleteAnnexe(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
